import { BrowserModule } from '@angular/platform-browser';
import {MatButtonToggleModule, MatIconModule} from '@angular/material'
import { NgModule } from '@angular/core';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {UtilService} from './common/_services/util.service';
import {ErrorHelper} from './common/_handlers/error.handler';
import {HeaderComponent} from './common/_components/header/header.component';
import {FooterComponent} from './common/_components/footer/footer.component';
import {MnewsDistModule} from './mnews-dist/mnews-dist.module';
import {RouterModule} from '@angular/router';
import {appRoutes} from './app.routes';
import {MatDatepickerModule, MatInputModule, MatNativeDateModule, MatProgressBarModule} from '@angular/material';
import {AppEventService} from './common/_services/event-broadcaster.service';
import {HttpService} from './common/_services/http.service';
import {AppStateService} from './common/_services/app.state.service';
import {AuthenticationService} from './common/_services/authentication.service';
import {AuthModule} from './auth/auth.module';
import { ClickOutsideModule } from 'ng4-click-outside';
import {ToastrModule} from 'ngx-toastr';
import {ConfirmBoxComponent} from './mnews-dist/_dialog_box/confirm-box/confirm-box.component';
import {MatDialogModule} from '@angular/material/dialog';
import { AudioRecordingService } from './mnews-dist/_services/audio-recording.service';
@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
    ],
    imports: [
        MatButtonToggleModule, MatIconModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        MnewsDistModule,
        RouterModule.forRoot(appRoutes, {useHash: true}),
        MatProgressBarModule,
        FormsModule, ReactiveFormsModule,
        ToastrModule.forRoot({
            positionClass: 'toast-center-center',
            timeOut: 2000,
            tapToDismiss : true
        }),
        AuthModule,
        MatInputModule,
        ClickOutsideModule,
        MatNativeDateModule,
        MatDatepickerModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [
        MatDatepickerModule,
        MatNativeDateModule
    ],
    providers: [
        HttpService,
        UtilService,
        AppEventService,
        ErrorHelper,
        HttpService,
        AppStateService,
        AuthenticationService,
        MatDatepickerModule,
        MatNativeDateModule,
        AudioRecordingService,
    ],
    bootstrap: [AppComponent],
    entryComponents: [
        ConfirmBoxComponent
    ],
})
export class AppModule {
}
